export default __webpack_public_path__ + "static/media/Wharton-gray.f0d96ce7.png";